import React from 'react';

const columnGeneral = [
  {
    title: 'CNES',
    dataIndex: 'cnes',
    key: 'cnes',
    width: 100,
  },

  {
    title: 'Período de referência (mês/ano)',
    dataIndex: 'periodo',
    key: 'periodo',
    width: 150,
  },

  {
    title: 'Total de internações no período de competência',
    dataIndex: 'total_internacoes',
    key: 'total_internacoes',
    width: 150,
  },

  {
    title: 'Total de partos vaginais realizados na instituição',
    dataIndex: 'partos_vaginais',
    key: 'partos_vaginais',
    width: 150,
  },

  {
    title: 'Total de partos (vaginal + cesáreo) realizados na instituição',
    dataIndex: 'partos',
    key: 'partos',
    width: 250,
  },

  {
    title:
      'Total de reinternações que ocorreram em até 30 dias após as saídas clínicas',
    dataIndex: 'int_cli',
    key: 'int_cli',
    width: 250,
  },

  {
    title: 'Total de saídas clínicas no mês anterior ao mês de competência',
    dataIndex: 'saidas_cli',
    key: 'saidas_cli',
    width: 250,
  },

  {
    title:
      'Total de reinternações que ocorreram em até 30 dias após as saídas cirúrgicas',
    dataIndex: 'int_cir',
    key: 'int_cir',
    width: 250,
  },

  {
    title: 'Total de saídas cirúrgicas no mês anterior ao mês de competência',
    dataIndex: 'saidas_cir',
    key: 'saidas_cir',
    width: 250,
  },

  {
    title: 'Total de PCRs na UI',
    dataIndex: 'pcr_ui',
    key: 'pcr_ui',
    width: 100,
  },

  {
    title: 'Total de pacientes-dia na UI',
    dataIndex: 'pd_ui',
    key: 'pd_ui',
    width: 100,
  },

  {
    title: ' Total de óbitos em pacientes NP com internação clínica',
    dataIndex: 'obitos_np_cli',
    key: 'obitos_np_cli',
    width: 250,
  },

  {
    title: ' Total de saídas de pacientes NP com internações clínicas',
    dataIndex: 'saidas_np_cli',
    key: 'saidas_np_cli',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes NT após 24 horas de internação    clínica',
    dataIndex: 'obitos_nt_cli',
    key: 'obitos_nt_cli',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes NT com internações clínicas',
    dataIndex: 'saidas_nt_cli',
    key: 'saidas_nt_cli',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes pediátricos após 24 horas de internação clínica',
    dataIndex: 'obitos_ped_cli',
    key: 'obitos_ped_cli',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes pediátricos com internações clínicas',
    dataIndex: 'saidas_ped_cli',
    key: 'saidas_ped_cli',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes adultos após 24 horas de internação clínica',
    dataIndex: 'obitos_adu_cli',
    key: 'obitos_adu_cli',
    width: 250,
  },

  {
    title: ' Total de saídas de pacientes adultos com internações clínicas',
    dataIndex: 'saidas_adu_cli',
    key: 'saidas_adu_cli',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes idosos após 24 horas de internação clínica',
    dataIndex: 'obitos_ido_cli',
    key: 'obitos_ido_cli',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes idosos com internações clínicas',
    dataIndex: 'saidas_ido_cli',
    key: 'saidas_ido_cli',
    width: 250,
  },

  {
    title: 'Total de óbitos em pacientes NP com internação cirúrgica',
    dataIndex: 'obitos_neop_cir',
    key: 'obitos_neop_cir',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes NP com internações cirúrgicas',
    dataIndex: 'saidas_neop_cir',
    key: 'saidas_neop_cir',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes NT após 24 horas de internação cirúrgica',
    dataIndex: 'obitos_neot_cir',
    key: 'obitos_neot_cir',
    width: 250,
  },

  {
    title: ' Total de saídas de pacientes NT com internações cirúrgicas',
    dataIndex: 'saidas_neot_cir',
    key: 'saidas_neot_cir',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes pediátricos após 24 horas de internação cirúrgica',
    dataIndex: 'obitos_ped_cir',
    key: 'obitos_ped_cir',
    width: 250,
  },

  {
    title:
      'Total de saídas de pacientes pediátricos com internações cirúrgicas',
    dataIndex: 'saidas_ped_cir',
    key: 'saidas_ped_cir',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes adultos após 24 horas de internação cirúrgica',
    dataIndex: 'obitos_adu_cir',
    key: 'obitos_adu_cir',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes adultos com internações cirúrgicas',
    dataIndex: 'saidas_adu_cir',
    key: 'saidas_adu_cir',
    width: 250,
  },

  {
    title:
      'Total de óbitos em pacientes idosos após 24 horas de internação cirúrgica',
    dataIndex: 'obitos_ido_cir',
    key: 'obitos_ido_cir',
    width: 250,
  },

  {
    title: 'Total de saídas de pacientes idosos com internações cirúrgicas    ',
    dataIndex: 'saidas_ido_cir',
    key: 'saidas_ido_cir',
    width: 250,
  },

  {
    title: 'Total de pacientes-dia pediátricos com internação clínica',
    dataIndex: 'pd_ped_cli',
    key: 'pd_ped_cli',
    width: 250,
  },

  {
    title:
      'Total de saídas de pacientes pediátricos com internação clínica (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_ped_cli_ti',
    key: 'saidas_ped_cli_ti',
    width: 300,
  },

  {
    title: 'Total de pacientes-dia adultos com internação clínica',
    dataIndex: 'pd_adu_cli',
    key: 'pd_adu_cli',
    width: 250,
  },

  {
    title:
      ' Total de saídas de pacientes adultos com internação clínica (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_adu_cli_ti',
    key: 'saidas_adu_cli_ti',
    width: 300,
  },

  {
    title: 'Total de pacientes-dia idosos com internação clínica',
    dataIndex: 'pd_ido_cli',
    key: 'pd_ido_cli',
    width: 250,
  },

  {
    title:
      'Total de saídas de pacientes idosos com internações clínicas (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_ido_cli_ti',
    key: 'saidas_ido_cli_ti',
    width: 300,
  },

  {
    title: ' Total de pacientes-dia pediátricos com internação cirúrgica',
    dataIndex: 'pd_ped_cir',
    key: 'pd_ped_cir',
    width: 250,
  },

  {
    title:
      'Total de saídas de pacientes pediátricos com internação cirúrgica (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_ped_cir_ti',
    key: 'saidas_ped_cir_ti',
    width: 300,
  },

  {
    title: 'Total de pacientes-dia adultos com internação cirúrgica',
    dataIndex: 'pq_adu_cir',
    key: 'pq_adu_cir',
    width: 150,
  },

  {
    title:
      'Total de saídas de pacientes adultos com internação cirúrgica (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_adu_cir_ti',
    key: 'saidas_adu_cir_ti',
    width: 300,
  },

  {
    title: 'Total de pacientes-dia idosos com internação cirúrgica',
    dataIndex: 'pd_ido_cir',
    key: 'pd_ido_cir',
    width: 250,
  },

  {
    title:
      'Total de saídas de pacientes idosos com internações cirúrgicas (excluindo obstétricos, psiquiátricos e internação prolongada)',
    dataIndex: 'saidas_ido_cir_ti',
    key: 'saidas_ido_cir_ti',
    width: 300,
  },

  {
    title:
      'Tempo da entrada do paciente na emergência até o término do atendimento',
    dataIndex: 'tempo_emergencia',
    key: 'tempo_emergencia',
    width: 250,
  },

  {
    title: 'Total de pacientes que buscaram atendimento na unidade',
    dataIndex: 'pac_emergencia',
    key: 'pac_emergencia',
    width: 250,
  },

  {
    title:
      'Total de tempo de espera para o primeiro atendimento em pacientes com classificação de risco nível 2',
    dataIndex: 'esp_1aten_n2',
    key: 'esp_1aten_n2',
    width: 250,
  },

  {
    title:
      ' Total de pacientes que buscaram atendimento na emergência com classificação de risco nível 2',
    dataIndex: 'pacientes_n2',
    key: 'pacientes_n2',
    width: 250,
  },

  {
    title:
      ' Total de tempo de espera para o primeiro atendimento em pacientes com classificação de risco nível 3',
    dataIndex: 'esp_1aten_n3',
    key: 'esp_1aten_n3',
    width: 250,
  },

  {
    title:
      ' Total de pacientes que buscaram atendimento na emergência com classificação de risco nível 3',
    dataIndex: 'pacientes_n3',
    key: 'pacientes_n3',
    width: 250,
  },

  {
    title:
      ' Total de cirurgias limpas com profilaxia antibiótica pré-cirúrgica',
    dataIndex: 'cir_lim_prof60m',
    key: 'cir_lim_prof60m',
    width: 200,
  },

  {
    title: 'Total de cirurgias limpas com exclusões',
    dataIndex: 'cir_lim',
    key: 'cir_lim',
    width: 100,
  },

  {
    title: 'Total de casos de ISC em cirurgias limpas',
    dataIndex: 'isc_cir_lim',
    key: 'isc_cir_lim',
    width: 200,
  },

  {
    title: 'Total de cirurgias limpas',
    dataIndex: 'total_cir_lim',
    key: 'total_cir_lim',
    width: 100,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UI Neonatal',
    dataIndex: 'ics_cvc_ui_neo',
    key: 'ics_cvc_ui_neo',
    width: 200,
  },

  {
    title: 'Total de pacientes em UI neonatal com CVC-dia',
    dataIndex: 'pac_ui_neo_cvcdia',
    key: 'pac_ui_neo_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UI Pediatrica',
    dataIndex: 'ics_cvc_ui_ped',
    key: 'ics_cvc_ui_ped',
    width: 200,
  },

  {
    title: 'Total de pacientes em UI Pediatrica com CVC-dia',
    dataIndex: 'pac_ui_ped_cvcdia',
    key: 'pac_ui_ped_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UI Adulta',
    dataIndex: 'ics_cvc_ui_adu',
    key: 'ics_cvc_ui_adu',
    width: 200,
  },

  {
    title: 'Total de pacientes em UI adulta com CVC-dia',
    dataIndex: 'pac_ui_adu_cvcdia',
    key: 'pac_ui_adu_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UTI Neonatal',
    dataIndex: 'ics_cvc_uti_neo',
    key: 'ics_cvc_uti_neo',
    width: 200,
  },

  {
    title: 'Total de pacientes em UTI neonatal com CVC-dia',
    dataIndex: 'pac_uti_neo_cvcdia',
    key: 'pac_uti_neo_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UTI Pediatrica',
    dataIndex: 'ics_cvc_uti_ped',
    key: 'ics_cvc_uti_ped',
    width: 200,
  },

  {
    title: 'Total de pacientes em UTI Pediatrica com CVC-dia',
    dataIndex: 'pac_uti_ped_cvcdia',
    key: 'pac_uti_ped_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ICS em pacientes com CVC em UTI Adulta',
    dataIndex: 'ics_cvc_uti_adu',
    key: 'ics_cvc_uti_adu',
    width: 200,
  },

  {
    title: 'Total de pacientes em UTI adulta com CVC-dia',
    dataIndex: 'pac_uti_adu_cvcdia',
    key: 'pac_uti_adu_cvcdia',
    width: 200,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UI Neonatal',
    dataIndex: 'itu_cvd_ui_neo',
    key: 'itu_cvd_ui_neo',
    width: 200,
  },

  {
    title: 'Total de pacientes em UI neonatal com CVD-dia',
    dataIndex: 'pac_ui_neo_cvddia',
    key: 'pac_ui_neo_cvddia',
    width: 200,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UI Pediatrica',
    dataIndex: 'itu_cvd_ui_ped',
    key: 'itu_cvd_ui_ped',
    width: 250,
  },

  {
    title: 'Total de pacientes em UI Pediatrica com CVD-dia',
    dataIndex: 'pac_ui_ped_cvddia',
    key: 'pac_ui_ped_cvddia',
    width: 200,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UI Adulta',
    dataIndex: 'itu_cvc_ui_adu',
    key: 'itu_cvc_ui_adu',
    width: 200,
  },

  {
    title: 'Total de pacientes em UI adulta com CVD-dia',
    dataIndex: 'pac_ui_adu_cvddia',
    key: 'pac_ui_adu_cvddia',
    width: 200,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UTI Neonatal',
    dataIndex: 'itu_cvd_uti_neo',
    key: 'itu_cvd_uti_neo',
    width: 250,
  },

  {
    title: 'Total de pacientes em UTI neonatal com CVD-dia',
    dataIndex: 'pac_uti_neo_cvddia',
    key: 'pac_uti_neo_cvddia',
    width: 250,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UTI Pediatrica',
    dataIndex: 'itu_cvc_uti_ped',
    key: 'itu_cvc_uti_ped',
    width: 250,
  },

  {
    title: 'Total de pacientes em UTI Pediatrica com CVD-dia',
    dataIndex: 'pac_uti_ped_cvddia',
    key: 'pac_uti_ped_cvddia',
    width: 250,
  },

  {
    title: 'Total de ITUs em pacientes com CVD em UTI Adulta',
    dataIndex: 'itu_cvc_uti_adu',
    key: 'itu_cvc_uti_adu',
    width: 250,
  },

  {
    title: 'Total de pacientes em UTI adulta com CVD-dia',
    dataIndex: 'pac_uti_adu_cvddia',
    key: 'pac_uti_adu_cvddia',
    width: 250,
  },

  {
    title:
      'Total de pacientes clínicos com risco trombótico não baixo que receberam profilaxia TEV',
    dataIndex: 'prof_tev_ris_tro_cli',
    key: 'prof_tev_ris_tro_cli',
    width: 250,
  },

  {
    title:
      'Total de pacientes clínicos com risco trombótico não baixo internados na instituição',
    dataIndex: 'ris_tro_cli',
    key: 'ris_tro_cli',
    width: 250,
  },

  {
    title:
      'Total de pacientes cirúrgicos ortopédicos com risco trombótico não baixo que receberam profilaxia TEV',
    dataIndex: 'prof_tev_ris_tro_cir_ort',
    key: 'prof_tev_ris_tro_cir_ort',
    width: 250,
  },

  {
    title:
      'Total de pacientes cirúrgicos ortopédicos com risco trombótico não baixo internados na instituição',
    dataIndex: 'ris_tro_cir_ort',
    key: 'ris_tro_cir_ort',
    width: 250,
  },

  {
    title:
      'Total de pacientes cirúrgicos não ortopédicos com risco trombótico não baixo que receberam profilaxia TEV',
    dataIndex: 'prof_tev_ris_tro_cir_nao_ort',
    key: 'prof_tev_ris_tro_cir_nao_ort',
    width: 250,
  },

  {
    title:
      ' Total de pacientes cirúrgicos não ortopédicos com risco trombótico não baixo internados na instituição',
    dataIndex: 'ris_tro_cir_nao_ort',
    key: 'ris_tro_cir_nao_ort',
    width: 250,
  },

  {
    title: 'Total de quedas com dano em pacientes',
    dataIndex: 'quedas',
    key: 'quedas',
    width: 150,
  },

  {
    title: ' Total de pacientes-dia',
    dataIndex: 'pd',
    key: 'pd',
    width: 120,
  },

  {
    title: 'Total de eventos sentinela',
    dataIndex: 'eve_sentinela',
    key: 'eve_sentinela',
    width: 150,
  },
];

export default columnGeneral;
